module.exports = __webpack_public_path__ + "static/media/settings.943f0167.md";